import { createSlice } from '@reduxjs/toolkit'
import { clrChannelDashboard } from './reducers/clr-channel-dashboard'
import { setChannelHighlightedRow } from './reducers/set-channel-highlighted-row'
import { setChannelRegistrationFormIsOpen } from './reducers/set-channel-registration-form-is-open'
import { setChannelQueryPagination } from './reducers/set-channel-query-pagination'
import { setChannelQueryFilters } from './reducers/set-channel-query-filters'
import { setTelegramActiveTab } from './reducers/set-telegram-active-tab'
import { setBotHighlightedRow } from './reducers/set-bot-highlighted-row'
import { setBotRegistrationFormIsOpen } from './reducers/set-bot-registration-form-is-open'
import { setBotQueryPagination } from './reducers/set-bot-query-pagination'
import { setBotQueryFilters } from './reducers/set-bot-query-filters'

export const channelDashboardInitialState = {
  channelHighlightedRow: null,
  channelRegisterationFormIsOpen: false,
  botHightlightedRow: null,
  botRegistrationFormIsOpen: false,
  tab: '1',
  channelQuery: {
    pagination: {
      page: 1,
      itemsPerPage: 10,
    },
    filters: {
      channelId: undefined,
      name: undefined,
      tags: undefined,
      isDeleted: undefined,
    },
  },
  botQuery: {
    pagination: {
      page: 1,
      itemsPerPage: 10,
    },
    filters: {
      botName: undefined,
      botUsername: undefined,
      botToken: undefined,
      tags: undefined,
      isDeleted: 'false',
    },
  },
}

export const initialState = {
  ...channelDashboardInitialState,
}

export const storeTelegram = createSlice({
  name: 'telegram',
  initialState,
  reducers: {
    setTelegramActiveTab,
    clrChannelDashboard,
    setChannelHighlightedRow,
    setChannelRegistrationFormIsOpen,
    setChannelQueryPagination,
    setChannelQueryFilters,
    setBotHighlightedRow,
    setBotRegistrationFormIsOpen,
    setBotQueryPagination,
    setBotQueryFilters,
  },
})
